import React from "react";
import { useQuery } from "react-query";
import { Link, useParams } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import testImg from "../../assets/images/logo.png";
import Loading from "../Shared/Loading";

const ConfirmOrder = () => {
  const { order_id } = useParams();

  const { data: order, isLoading } = useQuery("order", () =>
    fetch(`https://evening-peak-35730.herokuapp.com/order/${order_id}`).then(
      (res) => {
        return res.json();
      }
    )
  );

  if (isLoading) {
    return <Loading></Loading>;
  }

  let today = new Date();
  let date =
    today.getDate() + "-" + (today.getMonth() + 1) + "-" + today.getFullYear();

  const generateInvoicePDF = () => {
    const fileName = `hello_gas_satkania_invoice(${date})(${order?._id}).pdf`;
    var doc = new jsPDF("p", "pt", "a4");

    var pageWidth =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    doc.addImage(testImg, "JPG", 20, 0, 50, 50);
    doc.setFontSize(24);
    doc.setTextColor(3, 50, 104);
    doc.text("Hello-Gas-Satkania.", pageWidth / 2, 30, {
      align: "center",
    });
    autoTable(doc, { html: "#my-table" });
    autoTable(doc, {
      head: [["Product Name", "Quantity", "Price(per)"]],
      body: [
        [order?.product_name, order?.product_quantity, order?.product_price],
        [" ", "Total Amount", order?.product_price * order?.product_quantity],
      ],
    });

    doc.setFont("helvetica", "italic");
    doc.setFontSize(14);
    doc.setTextColor(3, 50, 104);
    doc.text(30, 160, `Ordered Date : ${date}`);

    doc.save(fileName);
  };

  return (
    <section className="flex justify-center">
      <div class="card bg-primary w-full md:w-6/12 rounded-xl p-6 space-y-4 mx-5">
        <h1 className="text-green-200 font-bold text-3xl text-center ">
          Order Confirmed
        </h1>
        <div className="pt-5 text-center text-green-200">
          <p className="text-xl">
            Thanks for choose{" "}
            <span className="text-neutral font-bold">Hello-Gas</span>
          </p>
          <p>We will contact with you within 5 minutes</p>
        </div>
        <p className="text-xl font-bold text-neutral pt-5">
          Ordered Date : {date}
        </p>
        <h3 className="text-xl text-neutral text-center pt-3">
          Product Details
        </h3>
        <img
          class="w-full h-64 rounded-md transition hover:bg-cyan-300"
          src={order?.product_image}
          alt="product_image"
        />
        <div id="description" class="space-y-4">
          <h2 class="text-white font-semibold text-xl transition hover:text-cyan-300 text-center">
            {order?.product_name}
          </h2>
          <div class="font-semibold text-sm pb-2">
            <p id="price" class="text-center text-accent text-xl">
              Per Gas Amount : {order?.product_price} Tk.
            </p>
            <p id="price" class="text-center text-neutral text-xl">
              Quantity : {order?.product_quantity} Tk.
            </p>
            <p id="price" class="text-center text-cyan-300 text-2xl">
              Total Amount : {order?.product_price * order?.product_quantity}{" "}
              Tk.
            </p>
          </div>
          <p className="text-neutral">Your Name : {order?.customer_name}</p>
          <p className="text-neutral">Mobile Number : {order?.mobile_number}</p>
          <p className="text-neutral">Address : {order?.address}</p>
          <div className="pt-3">
            <button
              onClick={generateInvoicePDF}
              className="btn btn-accent w-full mb-5 text-primary"
            >
              Download Invoice
            </button>
            <Link to="/" className="btn btn-secondary w-full">
              Back To Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfirmOrder;
